import { PageLayout } from '~/components/PageLayout/PageLayout';
import { useVerifyEmailMutation } from '../mutations';
import { useParams } from '~/hooks/useParams';
import { Fragment } from 'react/jsx-runtime';
import { useNavigate } from 'react-router';
import { tokenSchema } from '~/schemas';
import { useEffect } from 'react';

export function Page() {
  const { token } = useParams(tokenSchema.parse);

  const mutation = useVerifyEmailMutation();
  const navigate = useNavigate();

  useEffect(() => {
    if (mutation.isIdle) {
      mutation.mutate(
        { token },
        {
          onSuccess: () => navigate('/auth/sign-up/verify/success'),
          onError: () => navigate('/auth/sign-up/verify/error'),
        }
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Fragment>
      <Fragment>
        <PageLayout.Heading text="Verifierar din e-postadress..." />
        <p>Vi kontrollerar att din verifieringslänk är giltig. Detta kan ta några sekunder.</p>
      </Fragment>
    </Fragment>
  );
}
